<script>
    import { applyActionCode } from "firebase/auth";
    import { link } from "svelte-routing";

    export let auth;
    export let actionCode;
    // export let continueUrl;
    // export let lang;

    let promise = applyActionCode(auth, actionCode);
</script>

<div class="form">
    {#await promise then res}
        <h1>Verifizierung erfolgreich</h1>
        <p>Deine E-Mail-Adresse wurde erfolgreich bestätigt.</p>
        <a use:link href="/">Fertig</a>
    {:catch error}
        <h1>Verifizierung fehlgeschlagen</h1>
        <p>Der Link zum verifizieren der E-Mail-Adresse ist ungültig oder abgelaufen. Bitte verifiziere deine E-Mail-Adresse erneut.</p>
        <a use:link href="/">Zurück zur Startseite</a>
    {/await}
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }
</style>
